import React, {useState, useEffect} from "react";
import ApplicationService from "../../../../../services/ApplicationService/ApplicationService";
import Grid from "@material-ui/core/Grid";
import Search from "../../../../Search/Search";
import Divider from "@material-ui/core/Divider";
import {useTranslation} from "react-i18next";
import DoneIcon from '@material-ui/icons/Done';

export default function Apps(props) {
    const [searchData, setSearchData] = useState([])
    const [visibleAll, setVisibleAll] = useState(false);
    const {t} = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC.APPS."

    useEffect(() => {
        getApps().then(r => r);
    }, []);

    async function getApps() {
        const response = await ApplicationService.getApplications({on_cloud: 1});
        if (response && response.status && response.data.length) {
            if (props.selectedAppId) {

                const selectedAppIndex = response.data.findIndex(x => x.id === props.selectedAppId);
                if (selectedAppIndex > 0) {
                    const firstApp = {...response.data[0]};
                    response.data[0] = {...response.data[selectedAppIndex]};
                    response.data[selectedAppIndex] = firstApp;
                }
            }
            const data = response.data;
            props.setApps(data);
            setSearchData(data);
        }
    }

    const loadMoreApp = async () => {
        setVisibleAll(true);
    }

    return (
        <>
            <div className="form-element search-element margin-zero">
                <Search data={props.apps} setSearchData={setSearchData} xs={11} sm={11} md={11} lg={11} xl={11}
                        spacing={2}
                        customClasses={['trigger-search']}
                        searchKey={['name']}/>
            </div>

            <div className="apps-container">
                <Grid container spacing={3} className="app-grid-container">
                    {searchData?.length > 0 ? searchData?.map((item, i) => {
                        return (
                            <Grid item key={i} xs={6} sm={4} md={4} xl={3}
                                  className={`${i > 15 && !visibleAll ? 'hidden' : 'visible'}`}>
                                <div className="app-container">
                                    <div
                                        className={`app-icon app-${item.name.replace(' ', '-').toLowerCase()} ${props.selectedAppId === item.id ? 'selected' : ''}`}
                                        onClick={() => props.handleSetSelectedApp(item)}
                                    >
                                        {
                                            item.id === props.selectedAppId &&
                                            <DoneIcon className="trigger-done-icon top-position"/>
                                        }

                                        <img src={item.image_path} alt={item.name}/>
                                    </div>
                                    <div className="app-name">{item.name}</div>
                                </div>
                            </Grid>
                        )

                    }) : (
                        <Grid item xs={12} sm={12} md={12}
                              className="visible">
                            <div className="no-data-container">
                                <div className="no-data-pane">
                                    {t(label + "NO-APP-FOUND")}
                                </div>
                            </div>
                        </Grid>
                    )}
                    {searchData?.length > 16 && (
                        <div className={`load-more-container ${visibleAll ? 'hidden' : ''}`}>
                            <span onClick={loadMoreApp}>{t(label + 'LOAD-APPS')}</span>
                        </div>
                    )}

                </Grid>
            </div>
        </>
    )
}
